import React from 'react';
import { useSite, img } from '../lib/content';

// Official Millpond monogram - gold M on transparent background (CMS-editable).
const Logo = ({ size = 56 }) => {
  const site = useSite();
  return (
    <img
      src={img(site.logoMark)}
      alt={site.name || 'Millpond Gatherings'}
      width={size}
      height={size}
      className="object-contain select-none"
      draggable={false}
      style={{ width: size, height: size }}
    />
  );
};

export default Logo;
